import { render, staticRenderFns } from "./epmallordercomment.vue?vue&type=template&id=6e657171"
import script from "./epmallordercomment.vue?vue&type=script&lang=js"
export * from "./epmallordercomment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports